import { Container, Row } from "reactstrap";
import NestedSortableList from "./SortableList";
import { NesetditemList, SwapData } from "../../../Data/BonusUi/Tree";
import SortableSwapList from "./SortableSwapList";
import SimpleSortableList from "./SimpleSortableList";
import SharedSortableLists from "./SharedSortableLists";
import DisabledSortableList from "./DisabledSortableList";
import SortableHandleList from "./SortableHandleList";
import DraggableFilterList from "./DraggableFilterList";
import RandomSortableGrid from "./RandomSortableGrid";
import { Fragment } from "react/jsx-runtime";
import { Breadcrumbs } from "../../../AbstractElements";
import { BonusUi, TreeViewTitle } from "../../../Constants/Constants";

const TreeViewContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={TreeViewTitle} parent={BonusUi} />
      <Container fluid className="tree-page">
        <Row>
          <NestedSortableList items={NesetditemList} />
          <SortableSwapList items={SwapData} />
          <SimpleSortableList />
          <SharedSortableLists />
          <DisabledSortableList />
          <SortableHandleList />
          <DraggableFilterList />
          <RandomSortableGrid />
        </Row>
      </Container>
    </Fragment>
  );
};

export default TreeViewContainer;
